// Shared context, helpers and constants for all Brand Portal tabs.
// Extracted from the old monolithic BrandPortal.js so each tab can live
// in its own file without duplicating boilerplate.
import { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';

export const API = process.env.REACT_APP_BACKEND_URL + '/api';
export const stripePromise = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  ? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  : null;

export const BrandCtx = createContext(null);
export const useBrand = () => useContext(BrandCtx);

export function getHeaders() {
  const t = localStorage.getItem('propost_brand_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export function formatNum(n) {
  if (!n) return '0';
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return n.toLocaleString();
}
